import script from "./PagePreviousTimesheets.vue?vue&type=script&setup=true&lang=ts"
export * from "./PagePreviousTimesheets.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QSeparator});
